<template>
  <div class="DateSwiper">
    <Card :radius="0">
      <div class="picker-row">
        <div class="chevron-button" @click="slideDate(1)">
          <div class="fas fa-chevron-left"></div>
        </div>
        <div class="date">
          <DateInput v-model="innerDate" />
        </div>
        <p v-if="false" class="date">{{ value.format('YYYY/MM/DD') }}</p>
        <div class="chevron-button" @click="slideDate(-1)">
          <div class="fas fa-chevron-right"></div>
        </div>
      </div>
    </Card>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
import UiButton from '@/components/atoms/UiButton'
import Card from '@/components/atoms/Card'
import DateInput from '@/components/atoms/DateInput'
import moment from 'moment'

export default {
  name: 'DateSwiper',
  props: {
    value: {
      type: moment.Moment,
      default: new moment()
    },
  },
  components: {
    UiButton,
    Card,
    DateInput,
  },
  computed: {
    innerDate: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    slideDate(addNum) {
      const newDate = this.value.clone().add(addNum, 'days')
      this.$emit('input', newDate)
    },
  },
}
</script>

<style scoped lang="scss">
.picker-row {
  display: flex;
  align-items: center;
}

.date {
  font-size: 12px;
  flex: 1;
  text-align: center;
}

.chevron-button {
  font-size: 16px;
  padding: 12px 20px;
  cursor: pointer;
}
</style>
